import {
    Box,
    Button,
    Grid,
    Typography,
    Stack, Backdrop, CircularProgress, Alert, TextField
} from "@mui/material";
import {useNavigate, useNavigationType} from "react-router-dom";
import {Formik, useField} from "formik";
import styles from "../css/Home.module.css";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import React, {useEffect, useState} from "react";
import TextSearch from "./calculatorParts/TextSearch";
import TreeList from "./calculatorParts/TreeList";
import {getTextSearch, sendWorkOrder, getSystems} from "../serverREST";
import JobsTable from "./calculatorParts/JobsTable";
import {useDispatch, useSelector} from "react-redux";
import DetailsTable from "./calculatorParts/DetailsTable";
import SumTable from "./calculatorParts/SumTable";
import Print from "./calculatorParts/Print";
import {setJobs} from "../redux/jobsSlice";
import GenerateXML from "./calculatorParts/GenerateXML";
import store from "../redux/store";
import {LicensePlateInput, VinCodeInput} from "../components";
import {CalculatorCarProps} from "../components/CalculatorCarProps";
import { useTranslation } from 'react-i18next';

function ChooseWork({workID}) {
    const { t, i18n } = useTranslation();
    const licenseEnded = useSelector(state => state.license.licenseEnded)
    const licenseCountEnded = useSelector(state => state.license.licenseCountEnded)
    const WorkFlag = useSelector(state => state.settings.editWorkOrder);

    let isEdit = (WorkFlag === 1);
    if(!workID) isEdit = true;

    return (
        <Stack sx={{m: 1}} direction={'column'} style={{minWidth: '21em', width: '21%'}}>
            <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography variant={'h5'}>{t('system_catalog')}</Typography>
            </Stack>
            <Box className={styles.leftBar} flexGrow={1}>
                {licenseEnded && <Alert severity="error" sx={{m: 1}}>Нет активной лицензии</Alert>}
                {licenseCountEnded &&
                    <Alert severity="error" sx={{mt: 1}}>Запросы закончились, обратитесь к менеджеру</Alert>}
                {!licenseEnded && !licenseCountEnded &&
                    <>
                        {isEdit ?
                            <>
                                <TextSearch/>
                                <TreeList/>
                            </> :
                            <Alert severity="warning" sx={{m: 1}}>Редактирование старых заказ-нарядов запрещено на странице «Настройки приложения».
                                Вы можете изменить это, включив настройку «Разрешить редактирование сохранённых заказ-нарядов».</Alert>
                        }
                    </>
                }
            </Box>
        </Stack>
    )
}

function Car() {
    const [year] = useField('year');
    const [make] = useField('make');
    const [serie] = useField('serie');
    const [model] = useField('model');
    const [fuel] = useField('fuel');
    const [displacement] = useField('displacement');
    let today = new Date();
    return (
        <Typography variant={'h5'}>
            {year.value + ' ' +
                make.value.make + ' '
                + serie.value.serie + ' ' +
                (model.value && model.value.model_years ? model.value.model_years.replace(3000, today.getFullYear()) : '') + ' ' +
                (model.value && model.value.model_codes ? '(' + model.value.model_codes + ')' : '') + ' ' +
                (fuel.value && fuel.value.fuelName ? fuel.value.fuelName : '') + ' ' +
                (displacement.value && displacement.value.displacement !== '-' ? ' ' + Number(displacement.value.displacement).toFixed(1) : '')
            }
        </Typography>
    )
}

function Loading() {
    const showLoader = useSelector(state => state.lists.showLoader)

    return (
        <Backdrop
            sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={showLoader}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
    )
}

function Calculator() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const navigationType = useNavigationType();

    const formFromStorage = JSON.parse(sessionStorage.getItem('form'));

    useEffect(() => {
        getTextSearch(formFromStorage.model, formFromStorage.fuel, formFromStorage.displacement);
        getSystems();
    }, []);


    useEffect(() => {
        return () => {
            sendWorkOrder(formFromStorage.workorder_id);
        };
    });

    useEffect(() => {
        if (navigationType === 'POP') {
            if (formFromStorage.workorder_id) {
                //console.log('Restore order id:', formFromStorage.workorder_id);

                const workOrders = store.getState().lists.workOrders;
                const order = workOrders.find(v => v.workorder_id === formFromStorage.workorder_id);
                if (order) {
                    //console.log('Restore order:', order);
                    dispatch(setJobs(order.jobs));
                }
            }
        }
    }, []);

    return (
        <Formik initialValues={
            formFromStorage
        }
                validate={(values) => {
                    sessionStorage.setItem('form', JSON.stringify(values))
                }}
                onSubmit={
                    (values) => {
                    }
                }>
            <Grid container style={{height: '100%'}}>
                <ChooseWork workID={formFromStorage.workorder_id}/>
                <Grid item xs sx={{m: 1}}>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Car/>
                        <Button sx={{m: 1}}
                                variant={'outlined'}
                                startIcon={<AutorenewIcon/>}
                                onClick={() => {

                                    navigate('/repair-times')
                                }}>
                            Сменить автомобиль
                        </Button>

                    </Stack>

                    <CalculatorCarProps order={formFromStorage}/>

                    <JobsTable workID={formFromStorage.workorder_id}/>

                    <DetailsTable workID={formFromStorage.workorder_id}/>

                    <SumTable/>

                    <Stack direction={'row'} sx={{mt: 2}}>
                        <GenerateXML/>
                        <Print/>
                    </Stack>
                </Grid>
                <Loading/>
            </Grid>
        </Formik>
    )
}

export default Calculator